import { DesignSystemPrimitive } from 'designSystem/types';
import { resolveTokenValue } from 'designSystem/tokens/resolver';
import * as S from './styles';

interface CardPrimitivePreviewProps {
	primitive: DesignSystemPrimitive;
}

export const CardPrimitivePreview = ({ primitive }: CardPrimitivePreviewProps) => {
	// Create inline styles from CSS properties, resolving token references
	const inlineStyles: React.CSSProperties = {};
	primitive.properties.forEach((prop) => {
		const cssProp = prop.name.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
		const resolvedValue = resolveTokenValue(prop.value);
		if (cssProp === 'background' || cssProp === 'backgroundColor') {
			inlineStyles.background = resolvedValue;
		} else if (cssProp === 'borderRadius') {
			inlineStyles.borderRadius = resolvedValue;
		} else if (cssProp === 'border' || cssProp === 'borderColor') {
			inlineStyles.border = resolvedValue;
		} else if (cssProp === 'padding') {
			inlineStyles.padding = resolvedValue;
		} else if (cssProp === 'boxShadow') {
			inlineStyles.boxShadow = resolvedValue;
		}
	});

	return (
		<S.PrimitivePreview>
			<div
				style={{
					...inlineStyles,
					width: '100%',
					height: '60px',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					fontSize: '10px',
					color: '#666',
				}}
			>
				Card
			</div>
		</S.PrimitivePreview>
	);
};
